
<template>
    <v-container class="" style="padding: 6px;">
        <!-- >>> Resource was chosen: -------------------------------------- -->
        <v-row v-if="get_flights_ResourceDetails_ResourceAskedFor.idResource !== undefined">
            <!-- >>> Left Side: -------------------------------------------- -->
            <v-col cols="6" md="3">
                <v-card class="pa-2" style="background-color: #fff;" outlined>
                    <table id="customers">
                        <thead>
                            <tr>
                                <th style="background-color: #CB67A0;">
                                    <v-card-title style="text-align: left; font-weight: 600; font-size: 14px; color: #fff;">
                                        <p>{{ get_flights_ResourceDetails_ResourceAskedFor.genLastname }}, {{ get_flights_ResourceDetails_ResourceAskedFor.genFirstName }}</p>
                                        <p>{{ get_flights_ResourceDetails_ResourceAskedFor.contractFunction }} in {{ get_flights_ResourceDetails_ResourceAskedFor.contractBaseStationCode }}, {{ get_flights_ResourceDetails_ResourceAskedFor.comPhone1 }}</p>
                                    </v-card-title>
                                </th>
                            </tr>
                        </thead>
                    </table>
                </v-card>

                <v-card class="pa-2" style="margin-top: 10px; background-color: #fff;" outlined>
                    <v-card-text>
                        <datetime v-model="startDate" label="Brief Date:" disabled="false" disabledTime="true" ref="startTimer" briefcaller="step3" />
                    </v-card-text>
                </v-card>

                <v-card class="pa-2" min-height="276" style="margin-top: 10px; background-color: #fff;" outlined>
                     <v-card-text style="text-align: left; font-weight: 500; font-size: 16px;">
                        <!-- >>> 'Flights this Day': ------------------------ -->
                        <span style="text-align: left; font-weight: 600; font-size: 14px; text-decoration: underline;" v-if="flightsThisDay.length > 0">Flights this Day:</span>
                        <span style="text-align: left; font-weight: 600; font-size: 14px; text-decoration: underline;" v-if="flightsThisDay.length === 0">No Flights this Day:</span>
                        <template v-for="(flight, index) in flightsThisDay">
                            <p style="font-size: 13px; font-weight: 500;" :key="index"><strong>{{ flight.flight }}:</strong> {{ flight.hours }} (LT), {{ flight.leg }}: {{ flight.ft }}h</p>
                        </template>

                        <!-- >>> 'Sectors': -------------------------------- -->
                        <br /><p style="font-size: 13px; font-weight: 500;" v-if="sectorsThisDay !== null"><strong>Sectors: </strong>{{ sectorsThisDay }}</p><br />

                        <!-- >>> 'Total FT/DT': ------------------------------- -->
                        <p style="font-size: 13px; font-weight: 500;">
                            <span v-if="totalFTThisDay !== null"><strong>FT Total: </strong>{{ totalFTThisDay }}, </span>
                            <span v-if="totalDTThisDay !== null"><strong>DT Total: </strong>{{ totalDTThisDay }}</span>
                        </p><br />

                        <!-- >>> 'Restrictions': --------------------------- -->
                        <span style="text-align: left; font-weight: 600; font-size: 14px; text-decoration: underline;">Duty Time:</span>
                        <p style="font-size: 13px; font-weight: 500;"><strong>Next 7 days: </strong>{{ flightTimes.dtNex7Days }}h / max {{ flightTimes.maxdtNex7Days }}h
                            <span style="float: right;">
                                <div class="led-green" v-if="isRedOrGreen_FlightTimes({ semaforo: 'green', calculation: '7days' }) === 'green'"></div>
                                <div class="led-red" v-if="isRedOrGreen_FlightTimes({ semaforo: 'red', calculation: '7days' }) === 'red'"></div>
                            </span>
                        </p>

                        <p style="font-size: 13px; font-weight: 500;"><strong>Next 14 days: </strong>{{ flightTimes.dtNex14Days }}h / max {{ flightTimes.maxdtNex14Days }}h
                            <span style="float: right;">
                                <div class="led-green" v-if="isRedOrGreen_FlightTimes({ semaforo: 'green', calculation: '14days' }) === 'green'"></div>
                                <div class="led-red" v-if="isRedOrGreen_FlightTimes({ semaforo: 'red', calculation: '14days' }) === 'red'"></div>
                            </span>
                        </p>

                        <p style="font-size: 13px; font-weight: 500;"><strong>Next 28 days: </strong>: {{ flightTimes.dtNex28Days }}h / max {{ flightTimes.maxxdtNex28Days }}h
                            <span style="float: right;">
                                <div class="led-green" v-if="isRedOrGreen_FlightTimes({ semaforo: 'green', calculation: '28days' }) === 'green'"></div>
                                <div class="led-red" v-if="isRedOrGreen_FlightTimes({ semaforo: 'red', calculation: '28days' }) === 'red'"></div>
                            </span>
                        </p>

                        <p style="font-size: 13px; font-weight: 500;"><strong>This Year: </strong> {{ flightTimes.dtCurrentYear }}h / max {{ flightTimes.maxdtCurrentYear }}h
                            <span style="float: right;">
                                <div class="led-green" v-if="isRedOrGreen_FlightTimes({ semaforo: 'green', calculation: 'thisyear' }) === 'green'"></div>
                                <div class="led-red" v-if="isRedOrGreen_FlightTimes({ semaforo: 'red', calculation: 'thisyear' }) === 'red'"></div>
                            </span>
                        </p>

                    </v-card-text>
                </v-card>
            </v-col>
            <!-- <<< Left Side: -------------------------------------------- -->


            <!-- >>> Right Side: ------------------------------------------- -->
            <v-col cols="12" sm="6" md="9">
                <!-- >>> Table: -------------------------------------------- -->
                <v-card class="pa-2" min-height="480" style="background-color: #fff;" outlined>
                    <table class="MyFlightTimeTable">
                        <tbody>
                            <tr>
                                <td class="header_cell" style="">&nbsp;</td>
                                <td class="header_cell" style="">01</td>
                                <td class="header_cell" style="">02</td>
                                <td class="header_cell" style="">03</td>
                                <td class="header_cell" style="">04</td>
                                <td class="header_cell" style="">05</td>
                                <td class="header_cell" style="">06</td>
                                <td class="header_cell" style="">07</td>
                                <td class="header_cell" style="">08</td>
                                <td class="header_cell" style="">09</td>
                                <td class="header_cell" style="">10</td>
                                <td class="header_cell" style="">11</td>
                                <td class="header_cell" style="">12</td>
                                <td class="header_cell" style="">13</td>
                                <td class="header_cell" style="">14</td>
                                <td class="header_cell" style="">15</td>
                                <td class="header_cell" style="">16</td>
                                <td class="header_cell" style="">17</td>
                                <td class="header_cell" style="">18</td>
                                <td class="header_cell" style="">19</td>
                                <td class="header_cell" style="">20</td>
                                <td class="header_cell" style="">21</td>
                                <td class="header_cell" style="">22</td>
                                <td class="header_cell" style="">23</td>
                                <td class="header_cell" style="">24</td>
                                <td class="header_cell" style="">25</td>
                                <td class="header_cell" style="">26</td>
                                <td class="header_cell" style="">27</td>
                                <td class="header_cell" style="">28</td>
                                <td class="header_cell" style="">29</td>
                                <td class="header_cell" style="">30</td>
                                <td class="header_cell" style="">31</td>
                            </tr>
                            <tr>
                                <td class="header_cell" style="">jan</td>
                                <template v-for="(item, index) in yearlyList.january" >
                                    <td class="cell_with_value" v-if="item.dt !== null" :key="index">{{ item.dt }}</td>
                                    <td class="cell_empty" v-else :key="index">&nbsp;</td>
                                </template>
                            </tr>
                            <tr>
                                <td class="header_cell" style="">feb</td>
                                <template v-for="(item, index) in yearlyList.february" >
                                    <td class="cell_with_value" v-if="item.dt !== null" :key="index">{{ item.dt }}</td>
                                    <td class="cell_empty" v-else :key="index">&nbsp;</td>
                                </template>
                            </tr>
                            <tr>
                                <td class="header_cell" style="">mar</td>
                                <template v-for="(item, index) in yearlyList.march" >
                                    <td class="cell_with_value" v-if="item.dt !== null" :key="index">{{ item.dt }}</td>
                                    <td class="cell_empty" v-else :key="index">&nbsp;</td>
                                </template>
                            </tr>
                            <tr>
                                <td class="header_cell" style="">apr</td>
                                <template v-for="(item, index) in yearlyList.april" >
                                    <td class="cell_with_value" v-if="item.dt !== null" :key="index">{{ item.dt }}</td>
                                    <td class="cell_empty" v-else :key="index">&nbsp;</td>
                                </template>
                            </tr>
                            <tr>
                                <td class="header_cell" style="">may</td>
                                <template v-for="(item, index) in yearlyList.may" >
                                    <td class="cell_with_value" v-if="item.dt !== null" :key="index">{{ item.dt }}</td>
                                    <td class="cell_empty" v-else :key="index">&nbsp;</td>
                                </template>
                            </tr>
                            <tr>
                                <td class="header_cell" style="">jun</td>
                                <template v-for="(item, index) in yearlyList.june" >
                                    <td class="cell_with_value" v-if="item.dt !== null" :key="index">{{ item.dt }}</td>
                                    <td class="cell_empty" v-else :key="index">&nbsp;</td>
                                </template>
                            </tr>
                            <tr>
                                <td class="header_cell" style="">jul</td>
                                <template v-for="(item, index) in yearlyList.july" >
                                    <td class="cell_with_value" v-if="item.dt !== null" :key="index">{{ item.dt }}</td>
                                    <td class="cell_empty" v-else :key="index">&nbsp;</td>
                                </template>
                            </tr>
                            <tr>
                                <td class="header_cell" style="">aug</td>
                                <template v-for="(item, index) in yearlyList.august" >
                                    <td class="cell_with_value" v-if="item.dt !== null" :key="index">{{ item.dt }}</td>
                                    <td class="cell_empty" v-else :key="index">&nbsp;</td>
                                </template>
                            </tr>
                            <tr>
                                <td class="header_cell" style="">sep</td>
                                <template v-for="(item, index) in yearlyList.september" >
                                    <td class="cell_with_value" v-if="item.dt !== null" :key="index">{{ item.dt }}</td>
                                    <td class="cell_empty" v-else :key="index">&nbsp;</td>
                                </template>
                            </tr>
                            <tr>
                                <td class="header_cell" style="">oct</td>
                                <template v-for="(item, index) in yearlyList.october" >
                                    <td class="cell_with_value" v-if="item.dt !== null" :key="index">{{ item.dt }}</td>
                                    <td class="cell_empty" v-else :key="index">&nbsp;</td>
                                </template>
                            </tr>
                            <tr>
                                <td class="header_cell" style="">nov</td>
                                <template v-for="(item, index) in yearlyList.november" >
                                    <td class="cell_with_value" v-if="item.dt !== null" :key="index">{{ item.dt }}</td>
                                    <td class="cell_empty" v-else :key="index">&nbsp;</td>
                                </template>
                            </tr>
                            <tr>
                                <td class="header_cell" style="">dec</td>
                                <template v-for="(item, index) in yearlyList.december" >
                                    <td class="cell_with_value" v-if="item.dt !== null" :key="index">{{ item.dt }}</td>
                                    <td class="cell_empty" v-else :key="index">&nbsp;</td>
                                </template>
                            </tr>
                        </tbody>
                    </table>
                    <span style="font-size: 12px; font-weight: 500;">Note:</span><span style="font-size: 12pxem; font-weight: 400;"> Yearly Report Duty times</span>
                </v-card>
            </v-col>
            <!-- <<< Right Side: ------------------------------------------- -->
        </v-row>
        <!-- <<< Resource was chosen: -------------------------------------- -->




        <!-- >>> Resource was not chosen yet: ------------------------------ -->
        <v-row v-if="get_flights_ResourceDetails_ResourceAskedFor.idResource === undefined">
            <v-col cols="12">
                <v-card class="pa-2" style="background-color: #fff;">
                    <v-card-title class="pa-4" style="color: #CB67A0; font-size: 15px; font-weight: 500;">
                        <i style="font-size:20px; color: #A4C2A5;" class="b-fa b-fa-check-circle"></i> Attention: Dear User, first select a resource in the upper area (click checkbox).
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <!-- <<< Resource was not chosen yet: ------------------------------ -->
    </v-container>
</template>

<script>
    import Datetime from '../../DateTime.vue';
    import { mapGetters, mapActions } from 'vuex';
    import { eventBus } from '../../../../../../../main';


    export default {
        name: 'Step3Content',

        /* >>> *************************************************************** / /* Components */
        components : {

            Datetime,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                // >>> --------------------------
                yearlyList: {},
                flightsThisDay: [],
                sectorsThisDay: null,
                totalFTThisDay: null,
                totalDTThisDay: null,
                flightTimes: null,
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

            /******************************************************************* Picker
            * watch::get_flights_CrewDetails_SavedPayload
            *
            * Desc: Monitor/Watch ... 'get_flights_CrewDetails_SavedPayload'.
            * Note:
            *
            */
            get_flights_CrewDetails_SavedPayload(v) {

                let me = this,
                    timestamp = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/Step3Content.vue >>> watch get_flights_CrewDetails_SavedPayload');
                if (v.date !== undefined) {
                    timestamp = new Date(v.date).setHours(23, 59, 0, 0);
                    this.startDate = new Date(timestamp);
                }

            }, // eo function get_flights_CrewDetails_SavedPayload()


            /*******************************************************************
            * watch::get_flights_ResourceDetails_ReportsYearlyList
            *
            * Desc: Monitor/Watch ... 'get_flights_ResourceDetails_ReportsYearlyList'.
            * Note:
            *
            */
            get_flights_ResourceDetails_ReportsYearlyList(v) {

                this.yearlyList = v;

            }, // eo function get_flights_ResourceDetails_ReportsYearlyList()


            /******************************************************************* Brief
            * watch::get_flights_BriefDetails_Flights_ThisDay
            *
            * Desc: Monitor/Watch ... 'get_flights_BriefDetails_Flights_ThisDay'.
            * Note:
            *
            */
            get_flights_BriefDetails_Flights_ThisDay(v) {

                this.flightsThisDay = v;

            }, // eo function get_flights_BriefDetails_Flights_ThisDay()


            /*******************************************************************
            * watch::get_flights_BriefDetails_Sectors_ThisDay
            *
            * Desc: Monitor/Watch ... 'get_flights_BriefDetails_Sectors_ThisDay'.
            * Note:
            *
            */
            get_flights_BriefDetails_Sectors_ThisDay(v) {

                this.sectorsThisDay = v;

            }, // eo function get_flights_BriefDetails_Sectors_ThisDay()


            /*******************************************************************
            * watch::get_flights_BriefDetails_TotalFT_ThisDay
            *
            * Desc: Monitor/Watch ... 'get_flights_BriefDetails_TotalFT_ThisDay'.
            * Note:
            *
            */
            get_flights_BriefDetails_TotalFT_ThisDay(v) {

                this.totalFTThisDay = v;

            }, // eo function get_flights_BriefDetails_TotalFT_ThisDay()


            /*******************************************************************
            * watch::get_flights_BriefDetails_TotalDT_ThisDay
            *
            * Desc: Monitor/Watch ... 'get_flights_BriefDetails_Sectors_ThisDay'.
            * Note:
            *
            */
            get_flights_BriefDetails_TotalDT_ThisDay(v) {

                this.totalDTThisDay = v;

            }, // eo function get_flights_BriefDetails_TotalDT_ThisDay()


            /*******************************************************************
            * watch::get_flights_ResourceDetails_FlighTime_ResourceDutyAddendum
            *
            * Desc: Monitor/Watch ... 'get_flights_ResourceDetails_FlighTime_ResourceDutyAddendum'.
            * Note:
            *
            */
            get_flights_ResourceDetails_FlighTime_ResourceDutyAddendum(v) {

                this.flightTimes = v;

            }, // eo function get_flights_ResourceDetails_FlighTime_ResourceDutyAddendum()

        }, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_flights_CrewDetails_SavedPayload',
                'get_flights_ResourceDetails_ResourceAskedFor',
                'get_flights_ResourceDetails_ReportsYearlyList',
                // ------------------------------
                'get_flights_BriefDetails_Flights_ThisDay',
                'get_flights_BriefDetails_Sectors_ThisDay',
                'get_flights_BriefDetails_TotalFT_ThisDay',
                'get_flights_BriefDetails_TotalDT_ThisDay',
                'get_flights_ResourceDetails_FlighTime_ResourceDutyAddendum',
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/Step3Content.vue >>> created');
            eventBus.$on('onchangedatepickerbriefcall', this.onChange_DatePickerInBrief);

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/Step3Content.vue >>> beforeDestroy');
            eventBus.$off('onchangedatepickerbriefcall', this.onChange_DatePickerInBrief);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_call_getCrewDetailsResourceBrief_Reload'
            ]),


            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onChange_DatePickerInBrief()
            *
            * Desc:
            * Desc:
            *
            * @param {String} value ()
            */
            onChange_DatePickerInBrief: function(values){

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/Step4Content.vue >>> onChange_DatePickerInBrief');
                if (values.caller === 'step3') {
                    me.actn_call_getCrewDetailsResourceBrief_Reload({ date: values.date });
                }

            }, // eo function onChange_DatePickerInBrief()




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * isRedOrGreen_FlightTimes()
            *
            * Desc: Decide which traffic light.
            * Note:
            *
            * @param {Object} values (e.g.: { semaforo: 'red', calculation: '28days' })
            */
            isRedOrGreen_FlightTimes: function(values){

                let me = this,
                    semaforo = null,
                    timesSplit = [],
                    timeInMinutes1 = null,
                    timeInMinutes2 = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/Step4Content.vue >>> isRedOrGreen_FlightTimes');
                if (values.calculation === '7days') {
                    timesSplit = this.flightTimes.dtNex7Days.split(':');
                    timeInMinutes1 = (parseInt(timesSplit[0], 10) * 60) + parseInt(timesSplit[1], 10);
                    timeInMinutes2 = parseInt(this.flightTimes.maxdtNex7Days, 10) * 60;

                    if (timeInMinutes1 < timeInMinutes2) {
                        semaforo = 'green';
                    }
                    if (timeInMinutes1 > timeInMinutes2) {
                        semaforo = 'red';
                    }
                }

                if (values.calculation === '14days') {
                    timesSplit = this.flightTimes.dtNex14Days.split(':');
                    timeInMinutes1 = (parseInt(timesSplit[0], 10) * 60) + parseInt(timesSplit[1], 10);
                    timeInMinutes2 = parseInt(this.flightTimes.maxdtNex14Days, 10) * 60;

                    if (timeInMinutes1 < timeInMinutes2) {
                        semaforo = 'green';
                    }
                    if (timeInMinutes1 > timeInMinutes2) {
                        semaforo = 'red';
                    }
                }

                if (values.calculation === '28days') {
                    timesSplit = this.flightTimes.dtNex28Days.split(':');
                    timeInMinutes1 = (parseInt(timesSplit[0], 10) * 60) + parseInt(timesSplit[1], 10);
                    timeInMinutes2 = parseInt(this.flightTimes.maxxdtNex28Days, 10) * 60;

                    if (timeInMinutes1 < timeInMinutes2) {
                        semaforo = 'green';
                    }
                    if (timeInMinutes1 > timeInMinutes2) {
                        semaforo = 'red';
                    }
                }

                if (values.calculation === 'thisyear') {
                    timesSplit = this.flightTimes.dtCurrentYear.split(':');
                    timeInMinutes1 = (parseInt(timesSplit[0], 10) * 60) + parseInt(timesSplit[1], 10);
                    timeInMinutes2 = parseInt(this.flightTimes.maxdtCurrentYear, 10) * 60;

                    if (timeInMinutes1 < timeInMinutes2) {
                        semaforo = 'green';
                    }
                    if (timeInMinutes1 > timeInMinutes2) {
                        semaforo = 'red';
                    }
                }


                return semaforo;

            }, // eo function isRedOrGreen_FlightTimes()

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    #customers {
        border-collapse: collapse;
        width: 100%;
    }

    #customers td, #customers th {
        border: 1px solid #ddd;
        padding: 8px;
        font-size: 13px;
    }

    #customers td {
        font-weight: 500 !important;
    }


    #customers tr:nth-child(even){background-color: #f2f2f2;}

    #customers tr:hover {background-color: #ddd;}

    #customers th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: #A4C2A5;
        color: white;
        font-size: 14px;
        font-weight: 600 !important;
    }





    table.MyFlightTimeTable {
        background-color: #fff;
        width: 100%;
    }
    table.MyFlightTimeTable td {
        height: 25px;
        width: 31px;
        color: #fff;
        font-size: 13px;
        font-weight: 500;
        text-align: center;
    }
    table.MyFlightTimeTable .header_cell {
        background-color: #A4C2A5;
        color: #fff;
    }
    table.MyFlightTimeTable .cell_empty {
        background-color: #f3f4f5;
    }
    table.MyFlightTimeTable .cell_with_value {
        background-color: #CB67A0;

    }



    .led-green {
        margin: 0 auto;
        width: 14px;
        height: 14px;
        background-color: #A4C2A5;
        border-radius: 50%;
        /* box-shadow: rgb(0 0 0 / 20%) 0 -1px 7px 1px, inset #304701 0 -1px 9px, #89ff00 0 2px 12px; */
    }

    .led-red {
        margin: 0 auto;
        width: 14px;
        height: 14px;
        background-color: #ff0000;
        border-radius: 50%;
        /* box-shadow: rgb(0 0 0 / 20%) 0 -1px 7px 1px, inset #304701 0 -1px 9px, #e82e15 0 2px 12px; */
    }
</style>